export default __webpack_public_path__ + "static/media/logoLayout.465efbcd.png";